/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { useTranslation } from "react-i18next";

const SaveRolePopup = ({
  afterPopupCLose = () => {},
  roleId,
  setRoleId,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const titleRef = useRef(null);

  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = t("Role title cannot be empty. Please provide a title.");
    }

    if (!slug.trim()) {
      newErrors.slug = t(
        "Role slug cannot be empty. Please provide a unique slug."
      );
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (newErrors.name && titleRef.current) {
        setTimeout(() => {
          titleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          titleRef.current.setAttribute("tabindex", "-1");
          titleRef.current.focus();
        }, 100);
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  const getRoleDetails = async () => {
    setIsLoadingDetails(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ROLE_DETAILS +
        `/${roleId}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log("Role details response:", response);

      if (response.status) {
        const data = response.data;
        setName(data.name || "");
        setSlug(data.slug || "");
        setIsFeatured(data.featured || false);
      } else {
        console.error("Failed to fetch role details:", response.message);
        setAlertMessage(t("Failed to load role details: ") + response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error fetching role details:", error.message);
      setAlertMessage(t("An error occurred while fetching role details."));
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const saveHandler = async () => {
    if (!validateForm()) {
      setAlertMessage(
        t("Please correct the highlighted fields before saving.")
      );
      setMessageType("error");
      setShowAlert(true);
      return;
    }

    setIsSaving(true);
    try {
      let sendingData = {
        name,
        slug,
        featured: isFeatured,
      };

      console.log("Sending data:", sendingData);

      let requestUrlEndpoint;
      let response;

      if (roleId) {
        requestUrlEndpoint =
          url.API_UPDATE_ROLE + `/${roleId}` + `?token=${token}`;
        response = await putData(
          url.API_BASE_URL + requestUrlEndpoint,
          sendingData
        );
      } else {
        requestUrlEndpoint = url.API_ADD_ROLE + `?token=${token}`;
        response = await postData(
          url.API_BASE_URL + requestUrlEndpoint,
          sendingData
        );
      }

      console.log("API Response:", response);

      if (response.status) {
        if (window.bootstrap && window.bootstrap.Offcanvas) {
          const offcanvasElement = document.querySelector("#saveRole");
          const offcanvasInstance =
            window.bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (offcanvasInstance) {
            offcanvasInstance.hide();
          }
        }
        resetHandler();
        afterPopupCLose([response.data]);
        setAlertMessage(t("Role saved successfully!"));
        setMessageType("success");
        setShowAlert(true);
      } else {
        console.error("Save operation failed:", response.message);
        setAlertMessage(t("Failed to save role: ") + response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error saving role:", error.message);
      setAlertMessage(t("An error occurred while saving the role."));
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setIsSaving(false);
    }
  };

  const resetHandler = () => {
    setName("");
    setSlug("");
    setIsFeatured(false);
    setRoleId(null);
    setErrors({});
    setIsSaving(false);
    setIsLoadingDetails(false);
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (roleId) {
      getRoleDetails();
    } else {
      resetHandler();
    }
  }, [roleId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveRole"
      aria-labelledby="saveRole"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              person
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {roleId ? t("Edit Role") : t("Create Role")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {roleId
                ? t("Manage existing role details")
                : t("Define a new role")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4 pt-5">
        {isLoadingDetails && (
          <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 z-index-1050">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">
                {t("Loading role details...")}
              </span>
            </div>
            <p className="text-primary mt-3 fw-bold">
              {t("Loading role details...")}
            </p>
          </div>
        )}

        <div className="p-4 pb-5 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="labelName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  ref={titleRef}
                  type="text"
                  id="labelName"
                  className={`form-control fs-sm shadow-none ${
                    errors.name ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Team Leader")}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (errors.name) {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  aria-describedby="titleFeedback"
                />
                {errors.name && (
                  <div id="titleFeedback" className="invalid-feedback">
                    {errors.name}
                  </div>
                )}
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="slugID"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Slug")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="slug"
                  className={`form-control fs-sm shadow-none ${
                    errors.slug ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., team-leader")}
                  value={slug}
                  onChange={(e) => {
                    setSlug(e.target.value);
                    if (errors.slug) {
                      setErrors((prev) => ({ ...prev, slug: "" }));
                    }
                  }}
                  aria-describedby="slugFeedback"
                />
                {errors.slug && (
                  <div id="slugFeedback" className="invalid-feedback">
                    {errors.slug}
                  </div>
                )}
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                      <input
                        className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                        type="checkbox"
                        id="isFeatured"
                        checked={isFeatured}
                        onChange={(e) => setIsFeatured(e.target.checked)}
                      />
                      <label
                        className="form-check-label fw-semibold text-dark"
                        htmlFor="isFeatured"
                      >
                        {t("Featured")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-4 border-top mt-auto">
              <button
                onClick={saveHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Role")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveRolePopup;
